import { mapGetters } from "vuex";

import data from "@/mixins/data";
import components from "@/mixins/components";
import methods from "@/mixins/methods";

import IntersectionManager from "@/js/manager/intersection";
import MenuColor from "@/js/manager/menuColor";

import transitions from "@/transitions";

export default {
  mixins: [data, components, methods],
  data() {
    return {
      ready: false,
      menuColor: "",
    };
  },
  created() {
    let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    this.mobile = this.$store.state.ua.platform.type !== "desktop" || isSafari;
    if (process.env.NODE_ENV === "development") {
      console.info("view:", this.$options.name);
    }
    if (!process.env.VUE_APP_DEV_LANG && this.$attrs.lang)
      window.lang = this.$attrs.lang;
    window.addEventListener("resize", this.resize);
  },
  beforeDestroy() {
    this.menuColor && this.menuColor.destroy();
  },
  watch: {
    ready: function (ready) {
      if (ready) {
        if (this.page) {
          this.setPage(this.page);
          this.setMeta();
        } else {
          this.setPage(null);
        }
        transitions.in(this.resetTransition);
        if (
          this.$store.state.loader &&
          typeof this.$store.state.loader.hide === "function"
        ) {
          this.$store.state.loader.hide();
        }
        if (this.page && this.page.post_type) {
          this.$store.state.currentPage = this.page.post_type;
        }
        if (!this.menuColor) {
          this.menuColor = new MenuColor(this);
        }
        // console.log(this)
        this.$nextTick(() => {
          this.$intersection = new IntersectionManager(this);
          this.registerTransitionLinks();
          this.$nextTick(() => {
            if (typeof window !== "undefined") {
              window.prerenderReady = true;
              if (process.env.NODE_ENV !== "production") {
                console.log("[prerender] ready", new Date().toISOString());
              }
            }
          });
        });
      }
    },
  },
  updated: function () {
    // this.$nextTick(function () {
    //   setTimeout(() => {
    //     if (this.menuColor) this.menuColor.update()
    //   }, 500)
    // })
  },
  beforeRouteLeave(to, from, next) {
    if (to) this.prefetch(to, from, next);
    // timeout router transition event on link can occure before
    // console.log('ROUTER', this.$router.options.routes)
    // console.log('PAGE', to)
    setTimeout(() => {
      transitions.out(to, from, next);
    }, 100);
  },
  beforeRouteUpdate(to, from, next) {
    if (to) this.prefetch(to, from, next);
    console.log("transition");

    // timeout router transition event on link can occure before
    // console.log('ROUTER', this.$router)
    // console.log('PAGE', this.$route.query.page)
    setTimeout(() => {
      transitions.out(to, from, next);
    }, 100);
  },
  methods: {
    setMeta() {
      document.title = this.page.seo.title;
      document
        .querySelector('meta[name="description"]')
        .setAttribute("content", this.page.seo.description);
      document
        .querySelector('meta[property="og:title"]')
        .setAttribute("content", this.page.seo.title);
      document
        .querySelector('meta[property="og:description"]')
        .setAttribute("content", this.page.seo.description);
      document
        .querySelector('meta[property="og:image"]')
        .setAttribute("content", this.page.seo.image);
      document
        .querySelector('meta[property="og:url"]')
        .setAttribute("content", this.page.link);
      document
        .querySelector('link[rel="canonical"]')
        .setAttribute("href", this.page.link);
    },
    registerTransitionLinks() {
      let transitionsLinks = this.$el.querySelectorAll("[data-transition]");
      for (let i = 0; i < transitionsLinks.length; i++) {
        const link = transitionsLinks[i];
        link.addEventListener("click", () => {
          this.$store.state.transition.type = link.dataset.transition;
          this.$store.state.transition.entry = link;
        });
      }
    },
    prefetch(route, from, next) {
      // console.log('prefetch', route)
      const component = route.matched[0].components.default;
      const pageInfos = Object.assign(
        {},
        route.matched[0].props.default,
        route.params,
      );
      if (component.methods && component.methods.fetchData) {
        component.methods.fetchData(this.$store, pageInfos);
      }
      return true;
    },
    resize() {},
  },
};
